import { initValidationMethods } from './macmillan.donation.validatorMethods.js';
import { handleHiddenAddressFields, associateErrorMessage } from './validation.helpers.js';

/**
 * Intercepts form submission to ensure hidden address fields are revealed and validated.
 * This prevents data loss when users interact with the Loqate address finder.
 */
$('form#UserDetails').on('submit', function(e) {
    handleHiddenAddressFields(e, this);
});
// Function to remove existing error messages
const removeExistingErrors = (element) => {
    $(element).closest('.amounts--input-container').find('.messagebox').remove();
}

/**
 * jQuery Validation only wraps the error element when a `wrapper` option is
 * configured, so the message may be the element itself rather than one of its
 * descendants. Return whichever applies.
 */
const errorMessageOf = (error) => $(error).find('.error').addBack('.error');

const initDonateFormValidation = () => {
    // Resets the page to its default if a user goes back.
    $('.js-option-trigger input[checked=checked]').prop('checked', true);

    $("form.donateform").validate({
        onkeyup: false,
        errorElement: "p",
        errorClass: 'messagebox js error',
        errorPlacement: function (error, element, errorClass, validClass) {
            if (element.hasClass('taxPayerInput')) {
                error.appendTo(element.closest('.taxPayer--true').siblings('.taxPayer--false'));
            } else {
                error.appendTo(element.closest('div.row'));
            }
            const $errorMessage = errorMessageOf(error);
            $errorMessage.attr('role', 'alert');
            associateErrorMessage(element[0], $errorMessage[0]);
        },
        highlight: function (element, errorClass, validClass) {
            $(element).closest('div.row').addClass('errorbox');
            if (element.classList.contains('taxPayerInput')) {
                $(element).closest('.giftaid').addClass('errorbox').find('.taxPayer').addClass('errorbox');
            }

        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).closest('div.row').removeClass('errorbox');
            if (element.classList.contains('taxPayerInput')) {
                $(element).closest('.giftaid').removeClass('errorbox').find('.taxPayer').removeClass('errorbox');
            }
            element.removeAttribute('aria-describedby');
        },

        messages: {
            "Donation.Payment.DirectDebit.AccountNumber": {
                required: "Please include the full 8-digit account number",
                number: "Please a valid account number",
                rangelength: "Please include the full 8-digit account number"
            },
            "Donation.Payment.DirectDebit.SortCode": {
                required: "Please include the 6-digit sort code",
                number: "Please enter a valid sort code",
                rangelength: "Please include the 6-digit sort code"
            },
            "Donation.Payment.DirectDebit.AccountName": {
                required: "Please include the name of the account holder"
            },
            "TaxPayer": {
                required: "Please choose whether you would like to add Gift Aid"
            }
        },

        rules: {
            "Donation.Payment.DirectDebit.AccountNumber": {
                required: true,
                number: true,
                rangelength: [8, 8]
            },
            "Donation.Payment.DirectDebit.SortCode": {
                required: true,
                number: true,
                rangelength: [6, 6]
            },
            "Donation.Payment.DirectDebit.AccountName": {
                required: true
            },
            "TaxPayer": {
                required: true
            }
        }
    });
} // end initDonateForm

const initDonationTypeAndAmountValidation = () => {
    $("form[id$='DonationTypeAndAmount']").validate({
        onkeyup: function (element) {
            $(element).valid()
        },
        errorElement: "p",
        focusCleanup: false,
        wrapper: 'div',
        errorPlacement: function (error, field, errorClass, validClass) {
            // The wrapper option is also used as a selector by the plugin, so
            // the class has to be applied here rather than in the option.
            error.addClass('js');

            // Workaround to delete validate message from server side
            $('p[name="Donation_Payment_Amount"]').remove();
            $('span.field-validation-error.error').remove();

            error.appendTo(field.closest('div.fieldContainer'));
            const $errorMessage = errorMessageOf(error);
            $errorMessage.attr('role', 'alert');
            associateErrorMessage(field[0], $errorMessage[0]);
        },
        highlight: function (field, errorClass, validClass) {
            $(field).closest('div.row').addClass('errorbox');
        },
        unhighlight: function (field, errorClass, validClass) {
            $(field).closest('div.row').removeClass('errorbox');
            field.removeAttribute('aria-describedby');
        },
        rules: {
            "Donation.Payment.Amount": {
                required: true,
                min: function (element) {
                    return sessionStorage.getItem('donationType') == 'Regular' ? 2 : 0.01;
                },
                number: true
            },
            "Donation.DonationType": {
                required: true
            },
            "TeamReferenceNo": {
                number: true
            }
        },
        messages: {
            "Donation.DonationType": "Please tell us the type of donation you wish to make",
            "Donation.Payment.Amount": {
                min: function (element) {
                    return "Sorry, the minimum " + (sessionStorage.getItem('donationType') == 'Regular' ? 'regular' : 'one-off') + " donation we can accept is " + (sessionStorage.getItem('donationType') == 'Regular' ? '£2' : '1p');
                },
                required: "Please include the amount you want to donate",
                number: "Please enter a valid amount"
            },
            "TeamReferenceNo": "The team reference number can contain only numbers"
        }
    });
}

const initDonationAmountValidation = () => {
    $("form#DonationAmount").validate({
        onkeyup: false,
        errorElement: "p",
        errorClass: 'messagebox js error',
        errorPlacement: function (error, element, errorClass, validClass) {

            if (element.hasClass('amounts--amount')) {

                // Remove existing errors using the function
                removeExistingErrors(element);

                // Add the error message to the correct container and give id to it
                errorMessageOf(error).attr('id', 'amounts--amount-error');
                error.appendTo(element.closest('.amounts--input-container'));
                // Remove the for attribute from the error message if it's not a label
                if (this.errorElement !== "label") {
                    errorMessageOf(error).removeAttr('for');
                }
            }
            if (element.hasClass('otherRelation')) {
                error.appendTo(element.closest('.relations'));
            }

            errorMessageOf(error).attr('role', 'alert');
        },
        highlight: function (element, errorClass, validClass) {
            $(element).closest('.amounts--input-container').addClass('errorbox');

            if ($(element).hasClass('otherRelation')) {
                $(element).addClass('errorHighlight');
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).closest('.amounts--input-container').removeClass('errorbox');
            // Remove existing errors using the function
            removeExistingErrors(element);

            if ($(element).hasClass('otherRelation')) {
                $(element).removeClass('errorHighlight');
            }
        },

        messages: {
            "Donation.Payment.Amount.Hidden": {
                min: function (element) {
                    return "Sorry, the minimum " + (sessionStorage.getItem('donationType') == 'Regular' ? 'regular' : 'one-off') + " donation we can accept is " + (sessionStorage.getItem('donationType') == 'Regular' ? '£2' : '1p');
                },
                required: "Please include the amount you want to donate",
                number: "Please enter a valid amount",
                decimalAmountUptoTwoDigits: "Please enter a valid amount up to two decimal numbers"

            },
            "InMemoryOtherRelationship": {
                isNameFormat: "Please use only accented letters, hyphens, apostrophes and spaces."
            }
        },

        rules: {
            "Donation.Payment.Amount.Hidden": {
                required: true,
                number: true,
                min: function (element) {
                    return sessionStorage.getItem('donationType') == 'Regular' ? 2 : 0.01;
                },
                decimalAmountUptoTwoDigits: true

            },
            "InMemoryOtherRelationship": {
                isNameFormat: true
            }
        }
    });
}

const initUserdetailValidation = () => {
    $("form#UserDetails").validate({
        onkeyup: false,
        errorElement: "p",
        ignore: ":hidden",
        errorClass: 'messagebox js error',
        errorPlacement: function (error, element) {
            error.appendTo(element.closest('div.row'));
        },
        highlight: function (element, errorClass, validClass) {
            $(element).closest('div.row').addClass('errorbox');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).closest('div.row').removeClass('errorbox');
        },

        messages: {
            "Donation.Donor.Email": {
                required: "Please tell us your email address",
                email: "Please enter a valid email address"
            },
            "Donation.Donor.Title": {
                required: "Please include your title"
            },
            "Donation.Donor.FirstName": {
                required: "Please include your first name",
                isNameFormat: "First name accepts only accented letters, hyphens, apostrophes and spaces.",
                maxlength: "First name must be less than 32 characters"
            },
            "Donation.Donor.LastName": {
                required: "Please include your last name",
                isNameFormat: "Last name accepts only accented letters, hyphens, apostrophes and spaces.",
                maxlength: "First name must be less than 32 characters"
            },
            "Donation.Donor.Phone.Number": {
                phoneNumber: "Please enter a valid phone number."
            },
            "Donation.Donor.Address.PostalCode": {
                required: "Please include your postcode",
                postcode: "Postcode is invalid",
                maxlength: "Postcode must be less than 8 characters"
            },
            'Donation.Donor.Address.FirstLine': {
                required: "Please include the first line of your address"
            },
            'Donation.Donor.Address.PostalTown': {
                required: "Please include your town/city."
            },
            "Donation.Organisation.Name": {
                required: "Please include the organisation name"
            },
            "Donation.Organisation.Address.PostalCode": {
                required: "Please include your company's postcode",
                postcode: "Postcode is invalid",
                maxlength: "Postcode must be less than 8 characters"
            },
            "Donation.Organisation.Address.FirstLine": {
                required: "Please include organisation address"
            },
            'Donation.Organisation.Address.PostalTown': {
                required: "Please include your town/city."
            },
        },

        rules: {
            "Donation.Donor.Email": {
                email: true,
                required: true
            },
            "Donation.Donor.Title": {
                required: true
            },
            "Donation.Donor.FirstName": {
                required: true,
                consentRule: true,
                isNameFormat: true,
                maxlength: 32
            },
            "Donation.Donor.LastName": {
                required: true,
                consentRule: true,
                isNameFormat: true,
                maxlength: 32
            },
            "Donation.Donor.Address.PostalCode": {
                required: true,
                maxlength: 8,
                postcode: true,
                consentRule: true
            },
            'Donation.Donor.Address.FirstLine': {
                required: true,
                consentRule: true,
                maxlength: 50
            },
            'Donation.Donor.Address.SecondLine': {
                consentRule: true,
                maxlength: 50
            },
            'Donation.Donor.Address.ThirdLine': {
                consentRule: true,
                maxlength: 50
            },
            'Donation.Donor.Address.PostalTown': {
                required: true,
                consentRule: true,
                maxlength: 25
            },
            'Donation.Donor.Address.CountyProvince': {
                consentRule: true,
                maxlength: 25
            },
            "Donation.Donor.Phone.Number": {
                consentRule: true,
                phoneNumber: true,
                maxlength: 50
            },
            "Donation.Organisation.Name": {
                required: true,
                maxlength: 50
            },
            "Donation.Organisation.Address.PostalCode": {
                required: true,
                maxlength: 8,
                postcode: true,
                consentRule: true
            },
            "Donation.Organisation.Address.FirstLine": {
                required: true,
                maxlength: 50
            },
            "Donation.Organisation.Address.SecondLine": {
                maxlength: 50
            },
            "Donation.Organisation.Address.ThirdLine": {
                maxlength: 50
            },
            "Donation.Organisation.Address.PostalTown": {
                required: true,
                consentRule: true,
                maxlength: 25
            },
            'Donation.Organisation.Address.CountyProvince': {
                consentRule: true,
                maxlength: 25
            }
        }
    });
}; // end function

$(() => {
    initValidationMethods();
    initDonateFormValidation();
    initDonationTypeAndAmountValidation();
    initDonationAmountValidation();
    initUserdetailValidation();
});